import type { UserActionItem } from './types'

/**
 * Per-session equivalent of the composer send/stop button.
 *
 * <p>The composer shows Stop when {@code sending || awaitingUserAction} for the
 * <em>currently viewed</em> thread. The sidebar spinner uses the same "task is
 * not finished" predicate, but evaluated for each row:</p>
 *
 * <ul>
 *   <li>live SSE for that session (even after the user clicked 新对话 and parked it)</li>
 *   <li>open confirmation / question cards for that session</li>
 * </ul>
 */
export function isOpenUserAction(item: UserActionItem): boolean {
  const status = item.status
  if (item.type === 'confirmation') {
    return status == null || status === 'PENDING' || status === 'EXECUTING'
  }
  return status == null || status === 'PENDING'
}

export function sessionHasOpenUserAction(
  sessionId: string,
  queue: readonly UserActionItem[]
): boolean {
  return queue.some(
    (item) => item.conversationSessionId === sessionId && isOpenUserAction(item)
  )
}

export function isSessionTaskOpen(params: {
  sessionId: string
  hasLiveStream: boolean
  userActionQueue: readonly UserActionItem[]
}): boolean {
  const sid = params.sessionId.trim()
  if (!sid) {
    return false
  }
  if (params.hasLiveStream) {
    return true
  }
  return sessionHasOpenUserAction(sid, params.userActionQueue)
}
